export default function Vetting({ go }) {
  return (
    <div style={{ background: 'var(--warm)', minHeight: '100vh' }}>
      <style>{`
        .vetting-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: start; }
        .vetting-sticky { position: sticky; top: 90px; }
        .cred-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid var(--border); gap: 8px; }
        .cred-status { font-size: 12px; color: var(--text-light); text-align: right; flex-shrink: 0; }
        @media (max-width: 768px) {
          .vetting-grid { grid-template-columns: 1fr; gap: 2rem; }
          .vetting-sticky { position: static; }
          .cred-status { font-size: 11px; }
        }
      `}</style>

      {/* Header */}
      <div style={{ background: 'var(--teal-deeper)', padding: '56px 1.5rem' }}>
        <div className="container">
          <div style={{ fontSize:12, fontWeight:700, letterSpacing:2, color:'var(--teal-mid)', textTransform:'uppercase', marginBottom:12 }}>Our standard — no exceptions</div>
          <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(28px,5vw,52px)', color:'white', lineHeight:1.1, maxWidth:600, marginBottom:16 }}>Every caregiver passes our full verification</h1>
          <p style={{ fontSize:15, color:'rgba(255,255,255,.7)', lineHeight:1.75, maxWidth:540 }}>We never place a caregiver with a family until every single item on this list is confirmed. A pending check means they don't meet our families.</p>
        </div>
      </div>

      <div style={{ padding: '56px 1.5rem' }}>
        <div className="container">
          <div className="vetting-grid">

            {/* Left: checklist */}
            <div>
              {[
                ['🛡️','Vulnerable Sector Check (VSC)','Required','The highest level of Canadian police background check — specifically screens for sexual offences against children. Required under Alberta law for all childcare workers. Renewed annually.'],
                ['👶','Child Abuse Registry Clearance','Required','All caregivers are cleared through Alberta\'s Child Abuse Registry before joining our network. No exceptions.'],
                ['🩺','CPR Level C with AED & First Aid','Required','Standard First Aid + CPR Level C with AED from approved Alberta providers (Red Cross, St. John Ambulance). Certificate must be current — we track expiry dates.'],
                ['🪪','Government ID & Work Authorization','Required','Photo ID verified. Canadian citizenship, permanent residency, or valid work permit confirmed. Required for CRA employment compliance.'],
                ['📞','Professional References (minimum 2)','Required','We personally call and interview previous employers — not just emails. References from childcare settings only. Ebere asks the hard questions herself.'],
                ['❤️','Personal Interview by Founder Ebere','Required','Every caregiver is interviewed in person or by video by Ebere before joining. She only brings on people who share her standards for safety, warmth, and professionalism.'],
              ].map(([icon,title,badge,desc]) => (
                <div key={title} style={{ display:'flex', gap:'1.25rem', marginBottom:'2rem', paddingBottom:'2rem', borderBottom:'1px solid var(--border)' }}>
                  <div style={{ fontSize:26, flexShrink:0 }}>{icon}</div>
                  <div>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8, flexWrap:'wrap' }}>
                      <h4 style={{ fontSize:15, fontWeight:700, color:'var(--teal-deeper)' }}>{title}</h4>
                      <span style={{ background:'var(--coral)', color:'white', borderRadius:6, padding:'2px 8px', fontSize:10, fontWeight:700 }}>{badge}</span>
                    </div>
                    <p style={{ fontSize:13, color:'var(--text-mid)', lineHeight:1.7 }}>{desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Right: credential cards */}
            <div className="vetting-sticky">
              <div style={{ background:'white', border:'1px solid var(--border)', borderRadius:16, padding:'1.5rem', marginBottom:'1.5rem' }}>
                <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'var(--text-light)', marginBottom:16 }}>SAMPLE — CREDENTIAL CHECK ON FILE</div>
                {[
                  ['Vulnerable Sector Check','Cleared · Renewed annually'],
                  ['Child Abuse Registry','Cleared · Alberta HSS'],
                  ['CPR Level C with AED','Red Cross · Current'],
                  ['Standard First Aid','Certified · Current'],
                  ['Government ID verified','Work authorization confirmed'],
                  ['References (2+) verified','Personally called by Ebere'],
                  ['Founder interview completed','Approved by Ebere'],
                ].map(([item,status]) => (
                  <div key={item} className="cred-row">
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <div style={{ width:8, height:8, borderRadius:'50%', background:'#22c55e', flexShrink:0 }}/>
                      <span style={{ fontSize:13, fontWeight:500 }}>{item}</span>
                    </div>
                    <span className="cred-status">{status}</span>
                  </div>
                ))}
              </div>

              <div style={{ background:'white', border:'1px solid var(--border)', borderRadius:16, padding:'1.5rem', marginBottom:'1.5rem' }}>
                <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'#F5A623', marginBottom:12 }}>⚠ EXAMPLE — CAREGIVER NOT YET LISTED</div>
                {[['Vulnerable Sector Check','Pending — submitted'],['First Aid','Certified · Current']].map(([item,status]) => (
                  <div key={item} className="cred-row">
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <div style={{ width:8, height:8, borderRadius:'50%', background:'#F5A623' }}/>
                      <span style={{ fontSize:13, fontWeight:500 }}>{item}</span>
                    </div>
                    <span className="cred-status">{status}</span>
                  </div>
                ))}
                <p style={{ fontSize:12, color:'var(--coral)', fontWeight:600, marginTop:12 }}>⚠ Not shown to families until VSC is confirmed</p>
              </div>

              {/* Licence card */}
              <div style={{ background:'var(--teal-deeper)', borderRadius:16, padding:'1.75rem', textAlign:'center' }}>
                <div style={{ fontSize:11, fontWeight:700, letterSpacing:3, color:'var(--teal-mid)', marginBottom:12 }}>LICENSED BY GOVERNMENT OF ALBERTA</div>
                <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(28px,6vw,40px)', color:'white', fontWeight:600, marginBottom:8 }}>TN28080273</div>
                <div style={{ fontSize:14, color:'rgba(255,255,255,.7)', marginBottom:4 }}>Employment Agency Business Licence</div>
                <div style={{ fontSize:12, color:'var(--teal-mid)' }}>Regulated under Alberta's <em>Employment Agency Business Licensing Regulation</em></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}